export default __webpack_public_path__ + "static/media/flooring.52c9a3b3.jpg";